import React, { useEffect } from "react";

/**
 * Sends visitors to the canonical legal page on qiktruck.co.za.
 * Keeps /terms and /privacy routes working for old bookmarks without hosting duplicate copy.
 */
function ExternalLegalRedirect({ url, label }) {
  useEffect(() => {
    window.location.replace(url);
  }, [url]);

  return (
    <div style={{ padding: "4rem 1.5rem", textAlign: "center" }}>
      <p>
        Redirecting to {label} on{" "}
        <a href={url} rel="noopener noreferrer">
          qiktruck.co.za
        </a>
        ...
      </p>
    </div>
  );
}

export default ExternalLegalRedirect;
